import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isMoveKanbanTaskRequestFailure(): boolean {
      return getState().isFailure;
    },
    isMoveKanbanTaskRequestPending(): boolean {
      return getState().isPending;
    },
    isMoveKanbanTaskRequestSuccess(): boolean {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
